<template lang="pug">
.v-main-header.main-header(v-if="data && data?.image" )
	a.main-header__link(:href="data?.href || '#'")
		.main-header__logo(v-if="data.image" v-html="data.image" )
	.main-header__separator
	v-breadcrumbs.main-header__breadcrumbs

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>